import React from 'react';
import AdminPanel from './components/AdminPanel';
import './App.css';

function App() {
  return (
    <div className="App">
      <AdminPanel />
    </div>
  );
}

export default App;